// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProductReport":"eo_a bhp_a bhp_x bhp_j bhp_u bhp_bc bhp_ql bhp_vv"};